import React from "react";
import "./ModalErrorBox.css";

const ModalErrorBox = ({ onClose }) => (
  <div className="modal-error-backdrop">
    <div className="modal-error-dialog" role="dialog" aria-modal="true">
     
      <div className="modal-error-icon">
        <span>!</span>
      </div>
      <button
        className="modal-error-close"
        aria-label="Close error"
        onClick={onClose}
        type="button"
      >
        ×
      </button>
      <div className="modal-error-content">
        <strong style={{color: '#df4742', paddingBottom: '10px', fontWeight: 'bold'}}>Error saving your request</strong>
        <div className="modal-error-message">
          We have encountered an issue while saving your moderation visit request.
        </div>
        <div className="modal-error-secondline">
          Please can you try to submit your request again.
        </div>
        <div className="modal-error-details">
          If you are still having problems please&nbsp;
          <a style={{fontWeight: 'bold'}} href="mailto:support@ocr.org.uk">contact OCR</a>.
        </div>
      </div>
    </div>
  </div>
);

export default ModalErrorBox;
